<template>
  <div id="mark-modal-shop-select">
    <template v-if="isViewComponent()">
      <div class="row">
        <div class="col-12">
          <template v-if="hasItems()">
            <div class="card">
              <div class="card-header">
                <template v-if="isShopTypeOne()">
                  <h3 class="card-title">Для какого найденного магазина промаркировать пост?</h3>
                </template>
                <template v-if="isShopTypeMore()">
                  <h3 class="card-title">Для каких найденных магазинов промаркировать пост?</h3>
                </template>
              </div>
              <div class="list-group list-group-flush">
                <div class="list-group-item" v-for="item in getItems()" :key="row.getShopId(item)" @click="object.toggleItem(item, isShopTypeMore())">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <template v-if="isShopTypeOne()">
                        <input
                            type="radio"
                            class="form-check-input"
                            name="shop"
                            :checked="object.isChecked(item, false)"
                        >
                      </template>
                      <template v-if="isShopTypeMore()">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            :name="'shop['+ row.getCompositeId(item) +']'"
                            :checked="object.isChecked(item, true)"
                        >
                      </template>
                    </div>
                    <div class="col-auto">
                      <span class="avatar avatar-1" :style="{ backgroundImage: 'url('+ row.getShopImage(item, 50) +')'}"></span>
                    </div>
                    <div class="col text-truncate">
                      <div class="text-reset d-block">{{ row.getShopName(item) }}</div>
                      <div class="d-block text-secondary text-truncate mt-n1">{{ row.getShopHost(item) }}</div>
                      <template v-if="isShopTypeMore()">
                        <div class="text-reset d-block text-truncate mt-1" v-html="row.getCompositeText(item)"></div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            Магазины не обнаружены. Чтобы промаркировать пост, нужен хотя бы один магазин.
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-body">
        <div class="container-xl">
          <div class="row">
            <div class="mb-3">
              <div class="loader-item">
                <div class="spinner-border spinner-border-sm me-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, onUnmounted, reactive, ref, watch} from "vue"
import Helper from "@/services/Helper"
import Api from "./services/Api"
import ShopImage from "@/modules/shops/services/ShopImage"

export default defineComponent({
  name: "ShopSelect",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit, expose}) {
    let viewComponent = ref(false)
    let items = ref({})
    let shopType = ref(null)

    const payload = reactive({
      post_id: null,
    })

    let row = {
      getShopId: (item) => {
        return item["shop_id"]
      },
      getShopName: (item) => {
        return item["shop_name"]
      },
      getShopImage: (item, w) => {
        if (item["shop_image_host"] !== null && item["shop_image_name"] !== null) {
          return getImage(item["shop_image_host"], item["shop_image_name"], w)
        } else {
          return getImage(null, null, w)
        }
      },
      getShopHost: (item) => {
        return item["shop_host"]
      },
      getCompositeId: (item) => {
        return item["composite_id"]
      },
      getCompositeText: (item) => {
        return item["composite_text"]
      },
    }

    onMounted(() => {
      updatePayload(props.payload)

      if (!hasItems()) {
        Api.shops(getPostIdPayload()).then((resp) => {
          setItems(resp["items"])
          setShopType(resp["shop_type"])
          pushParent({}, resp["shop_type"])
          enableViewComponent()
        }).catch(() => {
          pushParent({}, null, true)
        })
      } else {
        enableViewComponent()
      }
    })

    onUnmounted(() => {
      disableViewComponent()
    })

    watch(() => props.payload, (newValues) => {
      updatePayload(newValues)
    })

    function getImage(host, name, w = null, h = null) {
      return ShopImage.handle(host, name, w, h)
    }

    function enableViewComponent() {
      viewComponent.value = true
    }

    function disableViewComponent() {
      viewComponent.value = false
    }

    function setShopType(val) {
      shopType.value = val
    }

    function getShopType() {
      return shopType.value
    }

    function isShopTypeOne() {
      return shopType.value === "one"
    }

    function isShopTypeMore() {
      return shopType.value === "more"
    }

    function updatePayload(query) {
      payload.post_id = query.post_id
    }

    function setItems(val) {
      items.value = val
    }

    function hasItems() {
      return !Helper.isEmptyObject(getItems())
    }

    function getItems() {
      return items.value
    }

    function getPostIdPayload() {
      return payload.post_id
    }

    function isViewComponent() {
      return viewComponent.value === true
    }

    function pushParent(shopItems, shopType, closeModal = false) {
      emit("changeVal", getResult(shopItems, shopType, closeModal))
    }

    function getResult(shopItems, shopType, closeModal) {
      return {
        shop_items: shopItems,
        shop_type: shopType,
        close_modal: closeModal,
      }
    }

    let object = {
      selectItems: ref({}),
      isChecked: (item, multiple) => {
        if (multiple === true) {
          let compositeId = row.getCompositeId(item)

          return object.selectItems.value[compositeId] !== undefined
        } else {
          let shopId = row.getShopId(item)

          return object.selectItems.value[shopId] !== undefined
        }
      },
      toggleItem: (item, multiple) => {
        if (multiple === true) {
          let shopId = row.getShopId(item)
          let compositeId = row.getCompositeId(item)

          if (object.selectItems.value[compositeId] !== undefined) {
            delete object.selectItems.value[compositeId]
          } else {
            object.selectItems.value[compositeId] = {
              "shop_id": shopId,
              "shop_host": null,
              "composite_id": compositeId,
              "category_id": null,
            }
          }
        } else {
          let shopId = row.getShopId(item)
          let shopHost = row.getShopHost(item)

          object.selectItems.value = {}

          object.selectItems.value[shopId] = {
            "shop_id": shopId,
            "shop_host": shopHost,
            "composite_id": null,
            "category_id": null,
          }
        }

        pushParent(object.selectItems.value, shopType.value)
      },
    }

    async function startRequest(postId) {
      return Api.category(postId).then((resp) => {
        return new Promise((resolve) => {
          console.log(resp)
          
          // todo а это раскомментить
          
          //let categoryId = resp["item"]["category_id"]
          //let categoryKktu = resp["item"]["category_kktu"]

          // todo потом это просто выпилить

          Object.entries(object.selectItems.value).forEach(([key]) => {
            object.selectItems.value[key] = Helper.mergeObject(object.selectItems.value[key], {
              category_id: '1.1.1',
            })
          })

          pushParent(object.selectItems.value, shopType.value)

          return resolve({
            "show_category": false,
            "shop_type": getShopType(),
          })

          // todo потом это просто выпилить

          // todo а это раскомментить

          /*if (categoryId === null || categoryKktu === null) {
            return resolve({
              "show_category": true,
              "shop_type": getShopType(),
            })
          }

          let countSeparator = categoryKktu.split(".").length - 1

          // если не последний уровень вложенности
          if (countSeparator < 2) {
            return resolve({
              "show_category": true,
              "shop_type": getShopType(),
            })
          }

          Object.entries(object.selectItems.value).forEach(([key]) => {
            object.selectItems.value[key] = Helper.mergeObject(object.selectItems.value[key], {
              category_id: categoryKktu,
            })
          })

          pushParent(object.selectItems.value, shopType.value)

          return resolve({
            "show_category": false,
            "shop_type": getShopType(),
          })*/
        })
      })
    }

    expose({ startRequest })

    return {
      isViewComponent,
      getItems,
      row,
      object,
      isShopTypeOne,
      isShopTypeMore,
      hasItems,
    }
  }
})
</script>
